<template>
  <div>
    <b-modal
      id="modal-atendimentos"
      ref="modalAtendimentos"
      title="Atendimentos"
      v-model="localEnabled"
      centered
      hide-footer
      size="lg"
      scrollable
      @hidden="handleClose"
    >
      <template #modal-title>
        <strong>{{ profissional?.no_profissional }}</strong>
      </template>
      <div class="atendimentos">
        <div class="row">
          <div class="col-md-4 col-12">
            <label for="datepicker-full-width">Data início</label>
            <input class="form-control" v-model="data_inicio" type="date" />
          </div>
          <div class="col-md-4 col-12">
            <label for="datepicker-full-width">Data fim</label>
            <input class="form-control" v-model="data_fim" type="date" />
          </div>
          <div class="row col-md-4 col-12">
            <div class="actions-buttons">
              <button type="button" class="btn" @click="filtrarPorDatas()">
                Filtrar <i class="icofont-search"></i>
              </button>
              <button type="button" class="btn" @click="clear()">
                Limpar <i class="icofont-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="info-table">
          <div class="info-table-item">
            <FonteSincronizadorC />
          </div>
          <div class="info-table-item">
            <b>{{ totalAtendimentos() }}</b> atendimentos realizados
          </div>
          <div class="info-table-item">
            <button class="btn-pdf" v-on:click="generatePdf()">
              <i class="icofont-print"></i> PDF
            </button>
          </div>
        </div>
        <table class="table table-responsive table-striped" id="table">
          <thead class="thead-light">
            <tr>
              <th>Data</th>
              <th>Dia</th>
              <th>Manhã</th>
              <th>Tarde</th>
              <th>Noite</th>
              <th>Não informado</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in atendimentosFiltrados"
              :key="index"
              :class="
                item.ds_dia_semana == 'Sábado' ||
                item.ds_dia_semana == 'Domingo'
                  ? 'table-row-color-red'
                  : ''
              "
            >
              <td>
                {{
                  item.dt_registro != null ? formatDate(item.dt_registro) : ''
                }}
              </td>
              <td>{{ item.ds_dia_semana ?? '' }}</td>
              <td>{{ item.qtd_manha ?? '' }}</td>
              <td>{{ item.qtd_tarde ?? '' }}</td>
              <td>{{ item.qtd_noite ?? '' }}</td>
              <td>{{ item.qtd_nao_informado ?? '' }}</td>
              <td class="text-center">
                <div v-if="item.qtd_total > 0">
                  <button
                    class="btn-table"
                    @click="atendimentosPorDia(item, index)"
                    :disabled="loadingRowIndex === index"
                  >
                    {{ item.qtd_total }}
                    <b-spinner
                      v-if="loadingRowIndex === index"
                      small
                      type="border"
                      label="Carregando"
                      variant="light"
                      class="ml-2"
                    />
                  </button>
                </div>
                <div v-else>
                  {{ item.qtd_total }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <ModalAtendimentosDia
      :enabled.sync="modalDiaEnabled"
      :profissional="profissional"
      :cadastros="atendimentosDoDia"
      :loading="loadingDiaModal"
      :dadosDoDia="dadosDoDia"
      @hidden="limparModalDia"
    />
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'
import ModalAtendimentosDia from './ModalAtendimentosDia.vue'

export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    atendimentos: {
      type: Array,
      default: () => [],
    },
    profissional: {
      type: Object,
      default: () => {},
    },
  },
  components: { ModalAtendimentosDia },
  mixins: [utils],
  data() {
    return {
      data_inicio: '',
      data_fim: '',
      atendimentosFiltrados: [],
      loadingRowIndex: null,
      dadosDoDia: null,
      atendimentosDoDia: [],
      loadingDiaModal: false,
      diaModal: null,
      modalDiaEnabled: false,
    }
  },
  computed: {
    localEnabled: {
      get() {
        return this.enabled
      },
      set(value) {
        this.$emit('update:enabled', value)
      },
    },
  },
  watch: {
    atendimentos: {
      handler(newVal) {
        this.atendimentosFiltrados = [...newVal] // Inicialmente copiar os atendimentos passados pela prop para a lista local
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Manipula o fechamento do modal.
     */
    handleClose() {
      this.$emit('update:enabled', false)
      this.clear()
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.atendimentosFiltrados,
        this.profissional.no_profissional,
        this.totalAtendimentos(),
        this.data_inicio,
        this.data_fim
      )
    },

    /**
     * Retorna a soma total de atendimentos
     * @returns {Number}
     */
    totalAtendimentos() {
      return this.atendimentosFiltrados.reduce(function (acc, obj) {
        let qtd_total = Number(obj.qtd_total) || 0
        return acc + qtd_total
      }, 0)
    },

    /**
     * Filtra os atendimentos por data inicial e final
     */
    filtrarPorDatas() {
      try {
        const dataInicial = new Date(this.data_inicio)
        const dataFinal = new Date(this.data_fim)
        this.atendimentosFiltrados = this.atendimentos.filter((cadastro) => {
          const dtAtendimento = new Date(cadastro.dt_registro)
          return dtAtendimento >= dataInicial && dtAtendimento <= dataFinal
        })
      } catch (error) {
        this.$toast.error('Data inválida!', 'Error:', {
          position: 'topRight',
        })
      }
    },

    /**
     * Limpa os campos
     */
    clear() {
      this.data_inicio = ''
      this.data_fim = ''
      this.atendimentosFiltrados = [...this.atendimentos]
    },

    /**
     * Busca os atendimentos por dia
     *
     * @param {Object} item
     * @param {Number} index
     */
    async atendimentosPorDia(item, index) {
      try {
        this.loadingRowIndex = index
        this.dadosDoDia = item

        const dia = item.dt_registro.replace(/\D/g, '')
        let cod = this.profissional.co_dim_profissional

        const response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/profissional/${cod}/${this.profissional.id_ficha}/${dia}`
        )
        if (response) {
          this.atendimentosDoDia = response.data
          this.modalDiaEnabled = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingRowIndex = null
        this.loadingDiaModal = false
      }
    },

    /**
     * Limpa os dados do modal dia
     */
    limparModalDia() {
      this.modalDiaEnabled = false
      this.atendimentosDoDia = []
      this.diaModal = null
    },
  },
}
</script>

<style lang="scss" scoped>
#modal-atendimentos {
  .actions-buttons {
    display: flex;
    align-items: flex-end;
    gap: 10px;
  }
  .table .thead-light th {
    text-transform: inherit;
    text-align: center;
  }
  .table tbody tr td {
    text-align: center;
  }
  .btn-table {
    &:disabled {
      color: #fff;
      background-color: #6c757d;
      border-color: #6c757d;
    }
  }
}
</style>
